import { Typography } from '@mui/material'
import { useState } from 'react'
import Button from '@/src/components/button'
import { useStore } from '@/src/types/store'

interface SummaryContent {
  summary?: string
  toggle?: boolean
}

interface TruncatedTextProps {
  question?: SummaryContent
  announcement?: SummaryContent
  maxLength: number
}

const TruncatedText = ({ announcement, question, maxLength }: TruncatedTextProps) => {
  const { TextColorType } = useStore()
  const [show, setShow] = useState(false)

  // Use whichever prop is passed (question takes priority)
  const content = question || announcement

  if (!content?.summary) return null

  const summaryText = content.summary.replaceAll('\n', '<br>')
  const isTruncated = summaryText.length > maxLength
  const displayText = show || !isTruncated ? summaryText : summaryText.substring(0, maxLength)

  // Determine toggle text
  const toggleText = question ? (show ? 'Read less' : 'Read more') : show ? 'See less' : 'See more'

  const shouldShowToggle = isTruncated && (question || content.toggle)

  return (
    <div className="overflow-hidden">
      <Typography
        variant="body1"
        color="text.secondary"
        dangerouslySetInnerHTML={{
          __html: displayText + (isTruncated && !show ? '...' : '')
        }}
        className="inline break-words [&_ul]:list-disc [&_ul]:pl-4 [&_ul]:break-words [&_li]:break-words"
      />
      {shouldShowToggle && (
        <div style={{ marginTop: '1px' }}>
          {question ? (
            <Button
              onClick={() => setShow(!show)}
              text={toggleText}
              extraClass={`rounded-[100px] ${
                TextColorType?.primaryTextDark
                  ? 'text-primary-home'
                  : TextColorType?.secondaryTextDark
                    ? 'text-secondary-home'
                    : 'text-black'
              }`}
              customStyle={true}
              variant="text"
            ></Button>
          ) : (
            <span
              onClick={() => setShow(!show)}
              className="text-secondary inline-block hover:text-blue-500 hover:underline focus:outline-none cursor-pointer"
            >
              <Typography
                variant="body1"
                color="text.secondary.home"
                className="hover:text-blue-500"
              >
                {toggleText}
              </Typography>
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default TruncatedText
